import { API_BASE_URL } from '../config';

export type OnboardingFinalizeResponse = {
  success: boolean;
  message: string;
  archivePath?: string;
  archivedVariousCopyCount?: number;
  archivedFormPdfCount?: number;
  deletedVariousCopyFileCount?: number;
  deletedFormRoundCount?: number;
  deletedSnapshotCount?: number;
  archiveFiles?: string[];
  alreadyFinalized?: boolean;
};

export type ArchiveFileItemApi = {
  code: string;
  side: string;
  fileName: string;
  relativePath: string;
  displayName: string;
};

export type OnboardingArchiveContentsApi = {
  invitationId: string;
  archivePath: string;
  variousCopies: ArchiveFileItemApi[];
  forms: ArchiveFileItemApi[];
};

export async function postOnboardingFinalize(
  email: string,
  invitationId: string
): Promise<OnboardingFinalizeResponse> {
  const res = await fetch(`${API_BASE_URL}/api/admin/onboarding-finalize`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.trim(), invitationId: invitationId.trim() }),
  });
  const data = (await res.json().catch(() => ({}))) as OnboardingFinalizeResponse & { message?: string };
  if (!res.ok) {
    throw new Error(typeof data.message === 'string' ? data.message : '登録完了処理に失敗しました。');
  }
  return data;
}

export function buildOnboardingArchiveZipUrl(email: string, invitationId: string): string {
  const params = new URLSearchParams({
    email: email.trim(),
    invitationId: invitationId.trim(),
  });
  return `${API_BASE_URL}/api/admin/onboarding-finalize/archive.zip?${params.toString()}`;
}

export function buildOnboardingArchiveFileUrl(
  email: string,
  invitationId: string,
  relativePath: string
): string {
  const params = new URLSearchParams({
    email: email.trim(),
    invitationId: invitationId.trim(),
    relativePath,
  });
  return `${API_BASE_URL}/api/admin/onboarding-finalize/archive-file?${params.toString()}`;
}

export async function fetchOnboardingArchiveContents(
  email: string,
  invitationId: string
): Promise<OnboardingArchiveContentsApi> {
  const params = new URLSearchParams({
    email: email.trim(),
    invitationId: invitationId.trim(),
  });
  const res = await fetch(
    `${API_BASE_URL}/api/admin/onboarding-finalize/archive-contents?${params.toString()}`
  );
  if (!res.ok) {
    const data = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(typeof data.message === 'string' ? data.message : 'アーカイブの取得に失敗しました。');
  }
  return res.json();
}

export async function downloadOnboardingArchiveZip(
  email: string,
  invitationId: string,
  fileName: string
): Promise<void> {
  const url = buildOnboardingArchiveZipUrl(email, invitationId);
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error('ZIPのダウンロードに失敗しました。');
  }
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(objectUrl);
}
